import React from 'react'
import { Card, Button, Row, message, Form, Input } from 'antd'
import { SchemaForm } from 'xadmin-form'
import { ResetPwdForm } from '../models'
import { Icon, C } from 'xadmin-ui'
import app, { api } from 'xadmin'
import sha1 from 'crypto-js/sha1'

const DefaultLayout = props => {
  const { children, invalid, handleSubmit, onDelete, schema, submitting, loading } = props;
  const { _t } = app.context;
  return (
    <Form className="form-horizontal" onFinish={handleSubmit} layout="vertical" autoComplete="on">
      <Card style={{ marginTop: 0, borderTop: 'none' }}>
        {children}
        <Row>
          <Button type="submit" htmlType="submit" className="loginBtn ant-btn-primary" loading={loading} disabled={invalid}>{_t('提交')}</Button>
        </Row>
      </Card>
    </Form>
  );
}

const ResetPwd = () => {
  const [loading, setLoading] = React.useState(false)

  const onSubmit = (value) => {
    setLoading(true)
    api({ name: 'core/register/admin' })
      .fetch('', {
        method: 'POST',
        body: JSON.stringify({ 
          password: sha1(value.password).toString(),
          password2: sha1(value.password2).toString()
        })
      })
      .then(({ json }) => {
        setLoading(false)
        document.cookie = `token=${json.token}`
        app.go('/systemSettingThird')
      })
  }

  return (
    <div className="setGuideCard">
      <div className="guideContent">
        <div className="loginGuide" >
          <div className="loginBox">
            <div className="cfix">
              <div className="rate-one">1</div>
              <span className="rate-span"></span>
              <div className="rate-one rate-none">2</div>
              {/* <span className="rate-span rate-span-none"></span>
              <div className="rate-one rate-none">3</div> */}
            </div>
            <p className="guideUse">初始化管理员密码</p>
            <p className="guideUse2">管理员账号为 <b>admin</b></p>
          </div>
          <SchemaForm
            formKey={'resetPwd'}
            schema={ResetPwdForm}
            component={props => <DefaultLayout {...props} loading={loading} />}
            group={C('Form.SimpleGroup')}
            onSubmit={(value) => onSubmit(value)}
          />
          {/* <Card className="loginBox">
            <p className="goReg goLogin" onClick={()=>app.go('/systemSettingTwo')}>跳过当前步骤</p>
          </Card> */}
        </div>
      </div>
    </div>
  )
}

export default ResetPwd
